export default __webpack_public_path__ + "static/media/pdfIcon.acf19468.svg";